import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import '../../styles/employee/personal-info.css';
import TopNavbar from '../top-navbar/TopNav';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const PersonalInfo = ({ candidateId,personalInfoResponse, onBack }) => {
    const navigate = useNavigate();
    const token = localStorage.getItem('bgc_token');
    const[error,setError] = useState('');
    const [formData, setFormData] = useState({
        candidateId: candidateId,
        firstName: '',
        lastName: '',
        email: '',
        dob: '',
        fatherName: '',
        aadharNumber: '',
        mobileNumber: '',
        candidateImage: '',
        remarks: '',
        verificationStatus: false,
    });
    const [formErrors, setFormErrors] = useState({
        remarks: '',
        verificationStatus: '',
    });
    useEffect(() => {
        if (personalInfoResponse) {
            //console.log("")
            setFormData({
                candidateId: candidateId || '',
                firstName: personalInfoResponse.firstName || '',
                lastName: personalInfoResponse.lastName || '',
                email: personalInfoResponse.email || '',
                dob: personalInfoResponse.dateOfBirth || '',
                fatherName: personalInfoResponse.fatherName || '',
                aadharNumber: personalInfoResponse.aadhaarCardNumber || '',
                mobileNumber: personalInfoResponse.mobileNumber || '',
                candidateImage: personalInfoResponse.personalImageFileName || '',
                remarks: '',
                
            });
        }
    }, [personalInfoResponse]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        setFormData(prev => ({ ...prev, [name]: newValue }));
        setFormErrors(prev => ({
        ...prev,
        [name]: '',
    }));
    };
const validateForm = () => {
    let isValid = true;
    const errors = { remarks: '', verificationStatus: '' };
 
    if (!formData.remarks.trim()) {
        errors.remarks = 'Remarks are required.';
        isValid = false;
    }
 
    if (!formData.verificationStatus) {
        errors.verificationStatus = 'Verification status must be checked.';
        isValid = false;
    }
 
    setFormErrors(errors);
    return isValid;
};
 
    const handleSubmit = async (e) => {
   e.preventDefault();

        setError(null);
            if (!validateForm()) {
        return; // Stop submit if validation fails
    }
            try {
                //console.log("input:"+JSON.stringify(formData));
                
                const response = await fetch(
                `https://trueface.co.in/api/employee/personal/verifyBackground`,
                {
                    method: 'POST',
                    headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                }
                );

                if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to verify personal background.');
                }

                const result = await response.json();
               toast.success("Personal Check data saved successfully", {
                autoClose: 3000, // 3 seconds
                });
                //console.log('Verification successful:', result);
               
                onBack();
              
            } catch (err) {
                console.error('Error during verification:', err);
                setError(err.message || 'An unexpected error occurred.');
            } finally {
              
            }
    };

    const handleCancel = () => {
        //console.log("Cancelled editing.");
        onBack();
    };

    PersonalInfo.propTypes = {
        candidateId: PropTypes.object,
        personalInfoResponse: PropTypes.object.isRequired,
        onBack: PropTypes.func.isRequired,
    };

    return (
        <div className="dashboard-app-container">
            <Sidebar />
            <div className="dashboard-right-panel">
                <TopNavbar />

                <div className="personal-info-header">
                        <h2>Personal Status</h2>
                    </div>

                <div className="personal-info-container">
                    
                    <div className="personal-details-card">
                        <h3>Personal Details</h3>
                        <form onSubmit={handleSubmit} className="personal-details-form">
                            <div className="form-row profile-pic-row">
                                <div className="profile-image-container">
                                    {formData.candidateImage ? (
                                        <img
                                            src={formData.candidateImage}
                                            alt="Candidate"
                                            className="candidate-profile-image"
                                        />
                                    ) : (
                                        <p className="candidate-profile-text">_candidate <br /> .profile</p>
                                    )}
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="firstName">First Name</label>
                                    <input type="text" id="firstName" value={formData.firstName} className="form-input" disabled />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="lastName">Last Name</label>
                                    <input type="text" id="lastName" value={formData.lastName} className="form-input" disabled />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="email">Email</label>
                                    <input type="email" id="email" value={formData.email} className="form-input" disabled />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="dob">Date of Birth</label>
                                    <input type="text" id="dob" value={formData.dob} className="form-input" disabled />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="fatherName">Father's Name</label>
                                    <input type="text" id="fatherName" value={formData.fatherName} className="form-input" disabled />
                                </div>
                                <div className="form-group">
                                    <label htmlFor="aadharNumber">Aadhar Number</label>
                                    <input type="text" id="aadharNumber" value={formData.aadharNumber} className="form-input" disabled />
                                </div>
                            </div>

                            <div className="form-row">
                                <div className="form-group">
                                    <label htmlFor="mobileNumber">Mobile Number</label>
                                    <input type="text" id="mobileNumber" value={formData.mobileNumber} className="form-input" disabled />
                                </div>
                            </div>

                            <div className="form-row remarks-row">
                                <div className="form-group full-width">
                                    <label htmlFor="remarks">Remarks</label>
                                    <textarea
                                        id="remarks"
                                        name="remarks"
                                        value={formData.remarks}
                                        onChange={handleChange}
                                        className="form-textarea"
                                        placeholder="Type here..."
                                    ></textarea>
                                    {formErrors.remarks && <p className="error-text">{formErrors.remarks}</p>}
                                </div>
                            </div>

                            <div className="form-group checkbox-group">
                                    <label>
                                        <input
                                            type="checkbox"
                                            name="verificationStatus"
                                            checked={formData.verificationStatus}
                                            onChange={handleChange}
                                        />{" "}
                                        Verification Status
                                    </label>
                                     {formErrors.verificationStatus && (
        <p className="error-text">{formErrors.verificationStatus}</p>
    )}
                                </div>

                            <div className="form-actions">
                                <button type="button" onClick={handleCancel} className="cancel-button">Cancel</button>
                                <button type="submit" className="submit-button">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PersonalInfo;
